"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.previewTemplate = void 0;
var tslib_1 = require("tslib");
var preview_dot_1 = (0, tslib_1.__importDefault)(require("./preview.dot"));
var previewTemplate = preview_dot_1.default.default ? preview_dot_1.default.default : preview_dot_1.default;
exports.previewTemplate = previewTemplate;
//# sourceMappingURL=index.js.map